import React from "react";
import { Segment, Grid, Icon, Rating } from "semantic-ui-react";

const TestDetailInfo = ({
    avgScore,
    testScore,
    handleRating,
    rating,
    totalUser
}) => {
    return (
        <Segment.Group>
            <Segment attached="top">
                <Grid>
                    <Grid.Column width={1}>
                        <Icon size="large" color="teal" name="info" />
                    </Grid.Column>
                    <Grid.Column width={12}>
                        <p>Average Score</p>
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <p>
                            <strong>{avgScore}</strong>
                        </p>
                    </Grid.Column>
                </Grid>
            </Segment>
            <Segment attached>
                <Grid verticalAlign="middle">
                    <Grid.Column width={1}>
                        <Icon name="calendar" size="large" color="teal" />
                    </Grid.Column>
                    <Grid.Column width={12}>
                        <span>Your Score</span>
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <p>
                            <strong>{testScore}</strong>
                        </p>
                    </Grid.Column>
                </Grid>
            </Segment>
            <Segment attached>
                <Grid verticalAlign="middle">
                    <Grid.Column width={1}>
                        <Icon name="star" size="large" color="teal" />
                    </Grid.Column>
                    <Grid.Column width={9}>
                        <span>Rating</span>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Rating
                            maxRating={5}
                            defaultRating={rating}
                            icon="star"
                            size="tiny"
                            onRate={handleRating}
                            style={{
                                float: "right"
                            }}
                        />
                        {/* <Button color="teal" size="tiny" content="Show Map" /> */}
                    </Grid.Column>
                    <Grid.Column width={2}>
                        <span>
                            <p>{`(${totalUser})`}</p>
                        </span>
                    </Grid.Column>
                </Grid>
            </Segment>
        </Segment.Group>
    );
};

export default TestDetailInfo;
